import { InvoiceState } from '@mynt/backoffice-api-spec/invoice'
import dayjs from 'dayjs'
import type React from 'react'
import { useState } from 'react'
import { AccountingTabs, TabSets } from '../helpers/TabsHelpers'
import Tabs from '../mynt-components/components/Tabs'
import { BankStatements } from '../pages/BankStatements'
import { Invoices } from '../pages/invoices'
import { OutboundPayments } from '../pages/OutboundPayments'
import { TextKeys } from '../tiger/libs/TextRepository'
import AccountsTable from './AccountsTable'
import { CardPayoutsTable } from './CardPayoutsTable'
import { PaymentsTable } from './PaymentsTable'
import TextContainer from './TextContainer'
import VouchersTable from './VouchersTable'
import YearsTable from './YearsTable'

const tabs = [
  {
    id: 'vouchers',
    labelElement: <TextContainer textKey={TextKeys.tabNotSelected} text={AccountingTabs.VOUCHERS} />,
    contentElement: <VouchersTable />,
    enable: true,
  },
  {
    id: 'accounts',
    labelElement: <TextContainer textKey={TextKeys.tabNotSelected} text={AccountingTabs.ACCOUNTS} />,
    contentElement: <AccountsTable />,
    enable: true,
  },
  {
    id: 'years',
    labelElement: <TextContainer textKey={TextKeys.tabNotSelected} text={AccountingTabs.YEARS} />,
    contentElement: <YearsTable />,
    enable: false,
  },
  {
    id: 'payouts',
    labelElement: <TextContainer textKey={TextKeys.tabNotSelected} text={AccountingTabs.PAYOUTS} />,
    contentElement: <CardPayoutsTable />,
    enable: true,
  },
  {
    id: 'payments',
    labelElement: <TextContainer textKey={TextKeys.tabNotSelected} text={AccountingTabs.PAYMENTS} />,
    contentElement: <PaymentsTable />,
    enable: true,
  },
  {
    id: 'invoices',
    labelElement: <TextContainer textKey={TextKeys.tabNotSelected} text={AccountingTabs.INVOICES} />,
    contentElement: (
      <Invoices
        page={'ACCOUNTING'}
        defaultFilters={{
          state: [
            InvoiceState.BOOKED,
            InvoiceState.DEBT_COLLECTION,
            InvoiceState.DRAFT,
            InvoiceState.OVER_DUE,
            InvoiceState.REMINDED,
            InvoiceState.REMINDER_OVERDUE,
          ],
          invoiceDate: {
            from: dayjs().subtract(1, 'months'),
            to: dayjs(),
          },
        }}
      />
    ),
    enable: true,
  },
  {
    id: 'bank-statements',
    labelElement: <TextContainer textKey={TextKeys.tabNotSelected} text={AccountingTabs.BANK_STATEMENTS} />,
    contentElement: <BankStatements />,
    enable: true,
  },
  {
    id: 'outbound-payments',
    labelElement: <TextContainer textKey={TextKeys.tabNotSelected} text={AccountingTabs.OUTBOUND_PAYMENTS} />,
    contentElement: <OutboundPayments />,
    enable: true,
  },
]

const Accounting: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0)

  return <Tabs fullPage alwaysShowNavHeadings tabKeyNameSpace={TabSets.ACCOUNTING} tabs={tabs} tab={activeTab} onTabChange={setActiveTab} />
}

export default Accounting
